const CloseNav = () => {
    return(
        <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="2.57358" y1="1.18085" x2="22.2332" y2="14.9467" stroke="#FE0002" stroke-width="2"/>
<line x1="1.42642" y1="15.1808" x2="21.0861" y2="1.41501" stroke="#FE0002" stroke-width="2"/>
</svg>

    )
}
export default CloseNav